// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/fatture/fatturabili?societaId',
    requestBody: null,
    response: '{"success":true,"data":[{"chiave":"string","sedeId":"number|null","sedeNome":"string|null","nominativoId":"number|null","clienteRagioneSociale":"string|null","documenti":[{"tipoDoc":"DDT|SAL","id":"number","numero":"string","data":"string|null","ordine":{"id":"number","numero":"string"},"commessa":{"id":"number","numero":"string","descrizione":"string"},"nRighe":"number","imponibileStimato":"number|null","storni":"number"}]}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/fatture/genera-composte',
    requestBody: '{"fatture":[{"tipoFattura":"DIFFERITA|IMMEDIATA","ddtIds":["number"],"salIds":["number"]}]}',
    response: '{"success":true,"data":{"risultati":[{"etichetta":"string","esito":"CREATA|SALTATO|ERRORE","fatturaId":"number","tipoFattura":"DIFFERITA|IMMEDIATA","clienteRagioneSociale":"string","totale":"number","nRighe":"number","motivo":"string"}],"create":"number"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
